import { createReducer, on } from '@ngrx/store';
import * as ReportActions from './cost-analysis.actions';
import { CostAnalysis } from './cost-analysis.model';

// ----------------------------------------------------------------------
// @ States
// ----------------------------------------------------------------------

export interface CostAnalysisState {
    Report: CostAnalysis | null;
    isLoading: boolean;
    isAvailable: boolean;
    error: string | null;
}

// ----------------------------------------------------------------------
// @ Initial States
// ----------------------------------------------------------------------

export const initialCostAnalysisState: CostAnalysisState = {
    Report: null,
    isLoading: false,
    isAvailable: false,
    error: null,
};

// ----------------------------------------------------------------------
// @ Reducers
// ----------------------------------------------------------------------

// Report
export const costAnalysisReducer = createReducer(
    initialCostAnalysisState,

    // On generate report
    on(ReportActions.generateCostAnalysis, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(ReportActions.generateCostAnalysisSuccess, (state, { report }) => ({
        ...state,
        isLoading: false,
        isAvailable: true,
        Report: report,
    })),
    on(ReportActions.generateCostAnalysisFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        isAvailable: false,
        error: error,
    })),

    // Clear
    on(ReportActions.clearPreviousCostAnalysis, (state) => ({
        ...state,
        isLoading: false,
        isAvailable: false,
        Report: null,
    }))
);
